module.exports = __webpack_public_path__ + "media/images/partners/institute-of-coding-d36a8d18ffc1848e09a537cac1f589f8.png";